import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetDispatcherSectorsParams,
    GetDispatcherSectorsResponse,
    DispatcherSectorPayload,
    DispatcherSectorFormPayload,
} from './types/dispatcher-sectors'

type ApiGetDispatcherSectorsResponse = Promise<AxiosResponse<GetDispatcherSectorsResponse>>
type ApiCreateDispatcherSectorResponse = Promise<AxiosResponse<void>>
type ApiUpdateDispatcherSectorResponse = Promise<AxiosResponse<void>>
type ApiDeleteDispatcherSectorResponse = Promise<AxiosResponse<void>>

export function getDispatcherSectors(
    params: GetDispatcherSectorsParams
): ApiGetDispatcherSectorsResponse {
    return http.get('/dispatcher/api/dispatcher-sectors', { params })
}

export function getAllDispatcherSectors(name?: string): ApiGetDispatcherSectorsResponse {
    const params = {
        name,
    }

    return http.get('/dispatcher/api/dispatcher-sectors/all', { params })
}

export function createDispatcherSector(
    payload: DispatcherSectorFormPayload
): ApiCreateDispatcherSectorResponse {
    return http.post('/dispatcher/api/dispatcher-sectors', payload)
}

export function updateDispatcherSector(
    dispatcher_sector_id: number,
    payload: DispatcherSectorFormPayload
): ApiUpdateDispatcherSectorResponse {
    return http.put(`/dispatcher/api/dispatcher-sectors/${dispatcher_sector_id}`, payload)
}

export function deleteDispatcherSector(
    dispatcher_sector_id: number
): ApiDeleteDispatcherSectorResponse {
    return http.delete(`/dispatcher/api/dispatcher-sectors/${dispatcher_sector_id}`)
}

export default {
    getDispatcherSectors,
    getAllDispatcherSectors,
    createDispatcherSector,
    updateDispatcherSector,
    deleteDispatcherSector,
}
